module.exports = __webpack_public_path__ + "img/statistics.98693e6c.svg";